module.exports = __webpack_public_path__ + "static/media/verkoopnou-logo.1b9e071a.png";